import { countries } from "countries-list";

export function getCountryName(country, native = true) {
	const nativeName = native ? `(${countries[country]?.native})` : "";

	return `${countries[country]?.name} ${nativeName}`;
}

export default countries;
